module.exports = __webpack_public_path__ + "media/icons/chevron-down-f60465c6.svg";